/* eslint-disable complexity, import/no-unassigned-import, react/forbid-component-props, sonarjs/cognitive-complexity, react-hooks/exhaustive-deps */
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { Element } from 'react-scroll';
import {
  CHOOSE_YOUR_OPTIONS_ACTIONS,
  SCROLL_INLINE_CALENDAR,
  CHOOSE_YOURS_OPTIONS_DEAL,
} from '../../../config/constants/scroll';
import { CYF_DEAL_TYPE } from '../../../config/setup/setup';
import { SHARE, CLAIM } from '../../../config/text/text';
import { isCreditecDeal } from '../../../helpers/creditec';
import {
  isBookingCalendarChooseDateDeal,
  getIsChooseYourOptionsDeal,
  isDealImagesCountLessThan,
  isDepositDeal,
  isBookingCalendarOnRedemptionDeal,
  isBookingCalendarOnRedemptionGiftDeal,
} from '../../../helpers/deals';
import {
  mainDealLayoutType,
  getScrollElementDealButtonType,
} from '../../../helpers/scroll';
import PayPalMessaging from '../../PayPalMessaging';
import BasketSocialCues from '../../checkout/BasketSocialCues';
import ClearpayMessaging from '../../clearpay/ClearpayMessaging';
import KlarnaMessaging from '../../klarna/KlarnaMessaging';
import MainDealReviewOverview from '../MainDealReviewOverview';
import MainDealShare from '../MainDealShare';
import VatText from '../shared-components/VatText';
import CalendarContainer from '../shared-components/booking-calendar/CalendarContainerDynamic';
import CalendarOnRedemptionContainer from '../shared-components/booking-calendar/CalendarOnRedemptionContainerDynamic';
import CreditecButton from '../shared-components/buy-buttons/CreditecButton';
import DealChooseYourOptionsClaimMessage from '../shared-components/buy-buttons/DealChooseYourOptionsClaimMessage';
import DealChooseYourOptionsModal, {
  layoutOptions,
} from '../shared-components/buy-buttons/DealChooseYourOptionsModal';
import ChooseYourOptionsMultiSelect from '../shared-components/buy-buttons/DealChooseYourOptionsMulti';
import DealViewAvailabilityButton from '../shared-components/buy-buttons/DealViewAvailabilityButton';
import ReserveButton from '../shared-components/buy-buttons/ReserveButton';
import CompanyLogos from '../shared-components/logos/CompanyLogos';
import ActionsMetaBlock from './ActionsMetaBlock';
import 'intersection-observer';

const Actions = ({
  buttonRef,
  deal,
  getButtons,
  getGiftingButton,
  selectedOption,
  isClaim = false,
  isClearpayDeal = false,
  isEvergreen,
  isExperienceBox = false,
  isGoogleHotel = false,
  isKlarnaDeal = false,
  isKlarnaPayInThree = false,
  isLeadGen,
  isOptionSelected,
  isPayPalDeal = false,
  isPaypalFeatured,
  isModernVipVariant = false,
  isSoldOut,
  mainDealBuyButton,
  pageDetails,
  searchParams,
  selectedOptions,
  setIsOptionSelected,
  setSelectedOptions,
  setShowMultiError,
  showMultiError,
  theme,
  toReviews,
  setShowEmptyMessage,
  setShowProductInfo,
  setIsCYOSelected,
}) => {
  const [isDuplicatedButton, setIsDuplicatedButton] = useState(true);
  const rightColumnRef = useRef(null);
  const proceedButtonRef = useRef(null);
  const isBookingCalendarChooseDate = isBookingCalendarChooseDateDeal(deal);
  const isBookingCalendarOnRedemption = isBookingCalendarOnRedemptionDeal(deal);
  const isBookingCalendarOnRedemptionGift = isBookingCalendarOnRedemptionGiftDeal(
    deal,
  );
  const isVipUser = useSelector((state) => state.user.userprofile?.vipUser);
  const isMarketingCreditDeal = isVipUser && deal.display.vipDiscountAllowed;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([observerEntry]) => {
        if (observerEntry.isIntersecting) {
          setIsDuplicatedButton(false);
        } else {
          setIsDuplicatedButton(true);
        }
      },
      {
        root: null,
        rootMargin: '35px 0px 0px 0px',
        threshold: 0.01,
      },
    );

    observer.observe(rightColumnRef.current);
    if (pageDetails?.isTravel && isBookingCalendarChooseDate) {
      observer.observe(proceedButtonRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [rightColumnRef, proceedButtonRef]);

  const scrollTargetName = getScrollElementDealButtonType(
    deal,
    mainDealLayoutType.actions,
    pageDetails.isTravel,
  );
  const positionActionButton = isDealImagesCountLessThan(deal, 4);
  const displayButtonsAtBottom = Boolean(!isLeadGen && isDuplicatedButton);
  const actionsTopStickPosition = () => {
    if (
      pageDetails.isTravel &&
      !isDepositDeal(deal) &&
      !isEmpty(scrollTargetName)
    ) {
      return '-87px';
    }

    if (pageDetails.isTravel && isDepositDeal(deal)) {
      return '-140px';
    }

    return '0px';
  };

  return (
    <>
      <div
        className={classNames('deal-main-deal__actions', {
          'deal-main-deal__actions--notravel': !pageDetails.isTravel,
        })}
      >
        <div ref={rightColumnRef} />
        <div className="proceed-availablity-io" ref={proceedButtonRef} />
        {
          <>
            {!isCreditecDeal(deal) &&
              getButtons('desktop', pageDetails, scrollTargetName)}
            {isCreditecDeal(deal) && <CreditecButton />}
            {isClaim && selectedOptions?.length <= 1 && (
              <DealChooseYourOptionsClaimMessage deal={deal} />
            )}
            <ReserveButton
              buttonRef={buttonRef}
              deal={deal}
              extraClasses={classNames(
                'reserve-button full-width outline margin',
                {
                  'hide-mobile': true,
                  'national-deal': !Boolean(pageDetails.isTravel),
                  'size-larger': Boolean(pageDetails.isTravel),
                },
              )}
              isOptionSelected={isOptionSelected}
              selectedOption={selectedOption}
              setShowEmptyMessage={setShowEmptyMessage}
            />
            {pageDetails.isTravel && (
              <>
                {deal?.giftable &&
                  (deal?.display?.dynamicTravelDeal ||
                    isBookingCalendarOnRedemptionGift) && (
                    <div className="deal-main-deal__calendar--side">
                      <DealViewAvailabilityButton
                        className="full-width"
                        deal={deal}
                        gift
                        isGoogleHotel={isGoogleHotel}
                        searchParams={searchParams}
                      />
                    </div>
                  )}
                <ActionsMetaBlock
                  deal={deal}
                  isTravel={pageDetails.isTravel}
                  pageDetails={pageDetails}
                  toReviews={toReviews}
                />
              </>
            )}
            {pageDetails.isTravel && getIsChooseYourOptionsDeal(deal) && (
              <div className="deal-main-deal__choose-your-options-deal--side">
                <Element name={CHOOSE_YOURS_OPTIONS_DEAL} />
                <DealChooseYourOptionsModal
                  buttonRef={buttonRef}
                  deal={deal}
                  isModernVipVariant={isModernVipVariant}
                  isOptionSelected={setIsOptionSelected}
                  layout={layoutOptions.travel}
                  setIsCYOSelected={setIsCYOSelected}
                />
              </div>
            )}
            {pageDetails.isTravel && (
              <>
                {isBookingCalendarOnRedemption && (
                  <div className="deal-main-deal__calendar--side">
                    <CalendarOnRedemptionContainer
                      buttonRef={buttonRef}
                      deal={deal}
                      isCalendarHidden
                      isGift
                      isTravel={pageDetails?.isTravel}
                      setIsOptionSelected={setIsOptionSelected}
                    />
                  </div>
                )}
                {isBookingCalendarChooseDate && (
                  <div className="deal-main-deal__calendar--side">
                    <Element name={SCROLL_INLINE_CALENDAR} />
                    <CalendarContainer
                      buttonRef={buttonRef}
                      deal={deal}
                      isCYF={deal.dealType === CYF_DEAL_TYPE}
                      isDynamicTravelDeal={deal?.display?.dynamicTravelDeal}
                      isGoogleHotel={isGoogleHotel}
                      isModernVipVariant={isModernVipVariant}
                      isTravel={pageDetails?.isTravel}
                      searchParams={searchParams}
                      setIsOptionSelected={setIsOptionSelected}
                    />
                  </div>
                )}
              </>
            )}
            {!isMobileOnly && pageDetails.isTravel && (
              <div className="deal-main-deal__multiple-options--side">
                <Element name={CHOOSE_YOUR_OPTIONS_ACTIONS} />
                <ChooseYourOptionsMultiSelect
                  className="cyo-main-deal"
                  deal={deal}
                  isClaim={isClaim}
                  isExperienceBox={isExperienceBox}
                  isModernVipVariant={isModernVipVariant}
                  isSoldOut={isSoldOut}
                  onChangeValues={(options) => setSelectedOptions(options)}
                  onSetShowMultiError={(show) => setShowMultiError(show)}
                  selectedOptions={selectedOptions}
                  showError={showMultiError}
                  text={isClaim ? CLAIM : null}
                />
              </div>
            )}
            {getGiftingButton('desktop', pageDetails, scrollTargetName)}
            {!isBookingCalendarOnRedemption && !isCreditecDeal(deal) && (
              <>
                <div className="deal-main-deal__social-cues--side">
                  <KlarnaMessaging deal={deal} sideBar />
                </div>
                <PayPalMessaging
                  deal={deal}
                  isFeatured={isPaypalFeatured}
                  isFeaturedSlot
                />
                <div className="deal-main-deal__social-cues--side">
                  <BasketSocialCues />
                </div>
              </>
            )}
            {!pageDetails.isTravel && (
              <div>
                <MainDealReviewOverview
                  deal={deal}
                  isTravel={pageDetails.isTravel}
                  toReviews={toReviews}
                />
              </div>
            )}
          </>
        }
        {!isCreditecDeal(deal) && (
          <>
            <div className="deal-main-deal__social-cues--side">
              <KlarnaMessaging
                deal={deal}
                isKlarnaDeal={isKlarnaDeal}
                isKlarnaPayInThree={isKlarnaPayInThree}
                isMarketingCreditDeal={isMarketingCreditDeal}
                sideBar
              />
            </div>
            <div className="deal-main-deal__social-cues--side">
              <ClearpayMessaging
                deal={deal}
                isClearpayDeal={isClearpayDeal}
                isMarketingCreditDeal={isMarketingCreditDeal}
                sideBar
              />
            </div>
            <div className="deal-main-deal__social-cues--side">
              <PayPalMessaging
                deal={deal}
                isFeatured={isPaypalFeatured}
                isFeaturedSlot={false}
                isMarketingCreditDeal={isMarketingCreditDeal}
                isPayPalDeal={isPayPalDeal}
              />
            </div>
          </>
        )}

        {!pageDetails.isTravel && (
          <div className="deal-main-deal__share--side">
            <h4>{SHARE}</h4>
            <MainDealShare deal={deal} />
          </div>
        )}
        <div className="deal-main-deal__company--logos">
          <CompanyLogos deal={deal} />
        </div>
        <div className="deal-main-deal__vat-text">
          <VatText deal={deal} setShowProductInfo={setShowProductInfo} />
        </div>
        {isEvergreen && (
          <div className="deal-main-deal__sku">SKU:&nbsp;{deal.id}</div>
        )}
        {/* duplicate for different buy button */}
        <div className="reserve-space">
          {displayButtonsAtBottom && mainDealBuyButton(false, scrollTargetName)}
          {displayButtonsAtBottom && (
            <ReserveButton
              buttonRef={buttonRef}
              deal={deal}
              extraClasses={classNames(
                'actions reserve-button full-width outline margin',
                {
                  'hide-mobile': true,
                  'national-deal': !Boolean(pageDetails.isTravel),
                  'size-larger': Boolean(pageDetails.isTravel),
                },
              )}
              isOptionSelected={isOptionSelected}
            />
          )}
        </div>
      </div>
      <style jsx>{`
        .proceed-availablity-io {
          left: 0;
          right: 0;
          height: 49px;
          display: block;
          bottom: 452px;
          position: absolute;
          z-index: -1;
        }
        .deal-main-deal__actions {
          padding-top: 8px;
          position: sticky;
          top: ${actionsTopStickPosition()};
          margin-bottom: 20px;
        }

        .deal-main-deal__actions--notravel {
          width: 182px;
          min-width: 182px;
        }

        :global(.main-deal-travel .deal-main-deal__actions) {
          min-width: 350px;
          width: 350px;
        }

        .reserve-space {
          min-height: 70px;
        }

        .deal-main-deal__sku {
          display: none;
          margin: 15px 0 0;
          font-size: 12px;
        }

        @media (min-width: ${theme.breakpoints.xlUp}) {
          :global(.main-deal-travel .deal-main-deal__actions) {
            min-width: ${isModernVipVariant ? '500px' : '457px'};
            width: ${isModernVipVariant ? '500px' : '457px'};
            margin-top: ${positionActionButton ? '10px' : '-85px'};
          }
        }
        @media (max-width: ${theme.breakpoints.xlDown}) {
          :global(.main-deal-travel .deal-main-deal__actions) {
            margin-top: ${positionActionButton ? '10px' : '-72px'};
          }
        }
        @media (max-width: ${theme.breakpoints.lgUp}) {
          :global(.main-deal-travel .deal-main-deal__actions) {
            margin-top: ${positionActionButton ? '10px' : '-50px'};
          }
        }

        .deal-main-deal__social-cues {
          margin-bottom: 20px;
        }
        .deal-main-deal__social-cues--side {
          padding: 0 8px;
          margin-bottom: 8px;
          font-size: ${pageDetails.isTravel ? '16px;' : '14px'};
        }

        .deal-main-deal__share--side {
          padding: 0 8px;
          margin-bottom: 16px;
        }

        @media (min-width: ${theme.breakpoints.xlUp}) {
          .deal-main-deal__vat-text--mobile {
            display: none;
          }
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          :global(.main-deal-travel .deal-main-deal__company--logos) {
            display: flex;
            justify-content: center;
            padding: 10px;
          }
        }

        .deal-main-deal__choose-your-options-deal--side,
        .deal-main-deal__multiple-options--side,
        .deal-main-deal__calendar--side {
          padding-right: 10px;
        }

        .deal-main-deal__calendar--side {
          margin-bottom: 10px;
        }

        @media (min-width: ${theme.breakpoints.mdUp}) {
          .deal-main-deal__sku {
            display: block;
          }
        }
      `}</style>
    </>
  );
};

Actions.propTypes = {
  buttonRef: PropTypes.object,
  deal: PropTypes.object.isRequired,
  getButtons: PropTypes.func.isRequired,
  getGiftingButton: PropTypes.func.isRequired,
  isClaim: PropTypes.bool,
  isClearpayDeal: PropTypes.bool,
  isEvergreen: PropTypes.bool.isRequired,
  isExperienceBox: PropTypes.bool,
  isGoogleHotel: PropTypes.bool,
  isKlarnaDeal: PropTypes.bool,
  isKlarnaPayInThree: PropTypes.bool,
  isLeadGen: PropTypes.bool.isRequired,
  isOptionSelected: PropTypes.bool,
  isPayPalDeal: PropTypes.bool,
  isPaypalFeatured: PropTypes.bool.isRequired,
  isSoldOut: PropTypes.bool.isRequired,
  mainDealBuyButton: PropTypes.func.isRequired,
  pageDetails: PropTypes.object.isRequired,
  searchParams: PropTypes.object,
  selectedOption: PropTypes.number,
  selectedOptions: PropTypes.array.isRequired,
  setIsOptionSelected: PropTypes.func,
  setSelectedOptions: PropTypes.func.isRequired,
  setShowEmptyMessage: PropTypes.func,
  setShowMultiError: PropTypes.func.isRequired,
  setShowProductInfo: PropTypes.func,
  showMultiError: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  toReviews: PropTypes.func.isRequired,
};
export default Actions;
